import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CC = function CC(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.5 16.5C9.08242 16.5 10.467 15.7212 11.2088 14.4973L9.50275 13.5082C9.13187 14.1758 8.37775 14.5714 7.5 14.5714C5.96703 14.5714 4.97802 13.5453 4.97802 12C4.97802 10.4547 5.96703 9.42857 7.5 9.42857C8.37775 9.42857 9.11951 9.82418 9.50275 10.4918L11.2088 9.50275C10.4547 8.27885 9.07006 7.5 7.5 7.5C4.89148 7.5 3 9.4533 3 12C3 14.5467 4.89148 16.5 7.5 16.5Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.9986 16.5C19.581 16.5 20.9656 15.7212 21.7074 14.4973L20.0013 13.5082C19.6305 14.1758 18.8763 14.5714 17.9986 14.5714C16.4656 14.5714 15.4766 13.5453 15.4766 12C15.4766 10.4547 16.4656 9.42857 17.9986 9.42857C18.8763 9.42857 19.6181 9.82418 20.0013 10.4918L21.7074 9.50275C20.9533 8.27885 19.5686 7.5 17.9986 7.5C15.3901 7.5 13.4986 9.4533 13.4986 12C13.4986 14.5467 15.3901 16.5 17.9986 16.5Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default CC;